import { render, staticRenderFns } from "./FleetArchivedTrucksLogs.vue?vue&type=template&id=333f9cc7&scoped=true&"
import script from "./FleetArchivedTrucksLogs.vue?vue&type=script&lang=js&"
export * from "./FleetArchivedTrucksLogs.vue?vue&type=script&lang=js&"
import style0 from "./FleetArchivedTrucksLogs.vue?vue&type=style&index=0&id=333f9cc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333f9cc7",
  null
  
)

export default component.exports